export enum ChartComponentType {
  LINE_BILLING,
  LINE_ORDER,
  PIE_ORDERS,
  PIE_ORDER_GRID,
  BAR_SALES,
  GENERIC,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/chart-component-type.enum.ts